<!-- Shared form field — compact, outlined, 1px hairline border, brand
     focus ring (the Lybits field density). Wraps <input> or <textarea>
     (multiline) with an optional label, hint and error. v-model-able.
     Extra attrs (e.g. type, autocomplete, min, step) fall through. -->
<template>
  <label class="block">
    <span v-if="label" class="mb-1 block text-xs font-medium text-muted">
      {{ label }}<span v-if="required" class="text-danger"> *</span>
    </span>
    <textarea
      v-if="multiline"
      :value="modelValue as string"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="control"
      v-bind="$attrs"
      @input="onInput"
    ></textarea>
    <input
      v-else
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="control"
      v-bind="$attrs"
      @input="onInput"
    />
    <span v-if="error" class="mt-1 block text-xs text-danger">{{ error }}</span>
    <span v-else-if="hint" class="mt-1 block text-xs text-faint">{{ hint }}</span>
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    modelValue?: string | number;
    label?: string;
    type?: string;
    placeholder?: string;
    hint?: string;
    error?: string;
    disabled?: boolean;
    required?: boolean;
    multiline?: boolean;
    rows?: number;
  }>(),
  { type: 'text', rows: 4 },
);

const emit = defineEmits<{ 'update:modelValue': [value: string] }>();
function onInput(e: Event): void {
  emit('update:modelValue', (e.target as HTMLInputElement | HTMLTextAreaElement).value);
}

const control = computed(() => [
  'form-in',
  props.error && 'border-danger focus:border-danger focus:shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-danger)_22%,transparent)]',
]);
</script>
